// extracted by mini-css-extract-plugin
export default {"giropay":"GiroPay_giropay__RCyZE","info":"GiroPay_info__PcQF6","submit":"GiroPay_submit__n2n7k","giropayFrame":"GiroPay_giropayFrame__NWLl3","spinner":"GiroPay_spinner__IvDX8"};